import rectroPc from "./news-homepage-main/assets/images/image-retro-pcs.jpg";
import topLaptops from "./news-homepage-main/assets/images/image-top-laptops.jpg";
import gamingGrowth from "./news-homepage-main/assets/images/image-gaming-growth.jpg";

const Section3 = () => {
    return ( 
        <section className="three">
            <div className="hottest">
                <div className="hottest-img">
                    <img src={rectroPc} alt="rectro-img" />
                </div>
                <div className="hottest-content">
                    <h2>01</h2>
                    <p className="sub-heading"><a href="/">Reviving Retro PCs </a></p>
                    <p className="about">What happens when old PCs are given modern upgrades?</p>
                </div>
            </div>
            <div className="hottest">
                <div className="hottest-img">
                    <img src={topLaptops} alt="top-laptops-img" />
                </div>
                <div className="hottest-content">
                    <h2>02</h2>
                    <p className="sub-heading"><a href="/">Top 10 Laptops of 2022 </a></p>
                    <p className="about">Our best picks for various needs and budgets.</p>
                </div>
            </div>
            <div className="hottest">
                <div className="hottest-img">
                    <img src={gamingGrowth} alt="gaming-growth-img" />
                </div>
                <div className="hottest-content">
                    <h2>03</h2>
                    <p className="sub-heading"><a href="/">The Growth of Gaming </a></p>
                    <p className="about">How the pandemic has sparked fresh opportunities.</p>
                </div>
            </div>
        </section>
     );
}
 
export default Section3;